export default {"src":"/_next/static/media/pentagon.be339bbe.svg","height":667,"width":824,"blurWidth":0,"blurHeight":0};